import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles(() => ({
  root: {
    flexGrow: 1
  },
  title: {
    flexGrow: 1
  },
  logo: {
    flexGrow: 1,
    width: "15vmin",
    height: "7vmin",
    margin: "1em"
  },
  menuButton: {
    flexGrow: 0
  }
}));
